/* tslint:disable */
/* eslint-disable */
/**
 * Seamworks API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { DataImportDto } from '../model/';
/**
 * DataImportApi - axios parameter creator
 * @export
 */
export const DataImportApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} [language] 
         * @param {number} [customerId] 
         * @param {number} [customSettingId] 
         * @param {string} [customSettingName] 
         * @param {string} [tktTex] 
         * @param {File} [data] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiImportApiUploadDBPost: async (language?: string, customerId?: number, customSettingId?: number, customSettingName?: string, tktTex?: string, data?: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/import/api/uploadDB`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (language !== undefined) {
                localVarQueryParameter['Language'] = language;
            }

            if (customerId !== undefined) {
                localVarQueryParameter['CustomerId'] = customerId;
            }

            if (customSettingId !== undefined) {
                localVarQueryParameter['CustomSettingId'] = customSettingId;
            }

            if (customSettingName !== undefined) {
                localVarQueryParameter['CustomSettingName'] = customSettingName;
            }

            if (tktTex !== undefined) {
                localVarQueryParameter['TktTex'] = tktTex;
            }


            if (data !== undefined) { 
                localVarFormParams.append('data', data as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} fileImportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiImportDownloadFailedRecordsFileImportIdGet: async (fileImportId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileImportId' is not null or undefined
            assertParamExists('apiImportDownloadFailedRecordsFileImportIdGet', 'fileImportId', fileImportId)
            const localVarPath = `/api/import/downloadFailedRecords/{fileImportId}`
                .replace(`{${"fileImportId"}}`, encodeURIComponent(String(fileImportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiImportFileImportIdGet: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('apiImportFileImportIdGet', 'id', id)
            const localVarPath = `/api/import/fileImport/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiImportGetLatestUploadedDBGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/import/getLatestUploadedDB`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {DataImportDto} [dataImportDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiImportPost: async (dataImportDto?: DataImportDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/import`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(dataImportDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} fileImportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiImportProgressFileImportIdGet: async (fileImportId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fileImportId' is not null or undefined
            assertParamExists('apiImportProgressFileImportIdGet', 'fileImportId', fileImportId)
            const localVarPath = `/api/import/progress/{fileImportId}`
                .replace(`{${"fileImportId"}}`, encodeURIComponent(String(fileImportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiReportGetCostFileReportGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/report/getCostFileReport`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DataImportApi - functional programming interface
 * @export
 */
export const DataImportApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DataImportApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} [language] 
         * @param {number} [customerId] 
         * @param {number} [customSettingId] 
         * @param {string} [customSettingName] 
         * @param {string} [tktTex] 
         * @param {File} [data] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiImportApiUploadDBPost(language?: string, customerId?: number, customSettingId?: number, customSettingName?: string, tktTex?: string, data?: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiImportApiUploadDBPost(language, customerId, customSettingId, customSettingName, tktTex, data, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataImportApi.apiImportApiUploadDBPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} fileImportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiImportDownloadFailedRecordsFileImportIdGet(fileImportId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiImportDownloadFailedRecordsFileImportIdGet(fileImportId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataImportApi.apiImportDownloadFailedRecordsFileImportIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiImportFileImportIdGet(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiImportFileImportIdGet(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataImportApi.apiImportFileImportIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiImportGetLatestUploadedDBGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiImportGetLatestUploadedDBGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataImportApi.apiImportGetLatestUploadedDBGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {DataImportDto} [dataImportDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiImportPost(dataImportDto?: DataImportDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DataImportDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiImportPost(dataImportDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataImportApi.apiImportPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} fileImportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiImportProgressFileImportIdGet(fileImportId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiImportProgressFileImportIdGet(fileImportId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataImportApi.apiImportProgressFileImportIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiReportGetCostFileReportGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiReportGetCostFileReportGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DataImportApi.apiReportGetCostFileReportGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DataImportApi - factory interface
 * @export
 */
export const DataImportApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DataImportApiFp(configuration)
    return {
        /**
         * 
         * @param {string} [language] 
         * @param {number} [customerId] 
         * @param {number} [customSettingId] 
         * @param {string} [customSettingName] 
         * @param {string} [tktTex] 
         * @param {File} [data] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiImportApiUploadDBPost(language?: string, customerId?: number, customSettingId?: number, customSettingName?: string, tktTex?: string, data?: File, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiImportApiUploadDBPost(language, customerId, customSettingId, customSettingName, tktTex, data, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} fileImportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiImportDownloadFailedRecordsFileImportIdGet(fileImportId: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiImportDownloadFailedRecordsFileImportIdGet(fileImportId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiImportFileImportIdGet(id: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiImportFileImportIdGet(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiImportGetLatestUploadedDBGet(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiImportGetLatestUploadedDBGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {DataImportDto} [dataImportDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiImportPost(dataImportDto?: DataImportDto, options?: RawAxiosRequestConfig): AxiosPromise<DataImportDto> {
            return localVarFp.apiImportPost(dataImportDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} fileImportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiImportProgressFileImportIdGet(fileImportId: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiImportProgressFileImportIdGet(fileImportId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiReportGetCostFileReportGet(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.apiReportGetCostFileReportGet(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DataImportApi - object-oriented interface
 * @export
 * @class DataImportApi
 * @extends {BaseAPI}
 */
export class DataImportApi extends BaseAPI {
    /**
     * 
     * @param {string} [language] 
     * @param {number} [customerId] 
     * @param {number} [customSettingId] 
     * @param {string} [customSettingName] 
     * @param {string} [tktTex] 
     * @param {File} [data] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataImportApi
     */
    public apiImportApiUploadDBPost(language?: string, customerId?: number, customSettingId?: number, customSettingName?: string, tktTex?: string, data?: File, options?: RawAxiosRequestConfig) {
        return DataImportApiFp(this.configuration).apiImportApiUploadDBPost(language, customerId, customSettingId, customSettingName, tktTex, data, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} fileImportId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataImportApi
     */
    public apiImportDownloadFailedRecordsFileImportIdGet(fileImportId: number, options?: RawAxiosRequestConfig) {
        return DataImportApiFp(this.configuration).apiImportDownloadFailedRecordsFileImportIdGet(fileImportId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataImportApi
     */
    public apiImportFileImportIdGet(id: number, options?: RawAxiosRequestConfig) {
        return DataImportApiFp(this.configuration).apiImportFileImportIdGet(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataImportApi
     */
    public apiImportGetLatestUploadedDBGet(options?: RawAxiosRequestConfig) {
        return DataImportApiFp(this.configuration).apiImportGetLatestUploadedDBGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {DataImportDto} [dataImportDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataImportApi
     */
    public apiImportPost(dataImportDto?: DataImportDto, options?: RawAxiosRequestConfig) {
        return DataImportApiFp(this.configuration).apiImportPost(dataImportDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} fileImportId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataImportApi
     */
    public apiImportProgressFileImportIdGet(fileImportId: number, options?: RawAxiosRequestConfig) {
        return DataImportApiFp(this.configuration).apiImportProgressFileImportIdGet(fileImportId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataImportApi
     */
    public apiReportGetCostFileReportGet(options?: RawAxiosRequestConfig) {
        return DataImportApiFp(this.configuration).apiReportGetCostFileReportGet(options).then((request) => request(this.axios, this.basePath));
    }
}

